import React from 'react'
import './header.scss'

const Header = () => {
	return (
		<>
			<div className='header'>
				<h1>TUNR</h1>
				<p>FOR ALL YOUR PLAYLIST NEEDS</p>
			</div>
		</>
	)
}

export default Header
